import { ReferenceLine } from 'recharts';
import { CartesianViewBox } from 'recharts/types/util/types';
import { theme } from '@frontend/theme';
import { Marker } from '../types';

//  Due to limitation with rechart, we need to export and use it as a function
export const renderHorizontalMarker = (
  markers?: Marker[],
  colors?: Record<string, string>,
  hideMarkerEnds?: boolean
) => {
  return markers?.map(({ color, dottedLine = true, formatter, id, label, size = 2, value }) => (
    <ReferenceLine
      ifOverflow='extendDomain'
      key={id}
      label={{
        content: ({ viewBox }) => {
          const { x = 0, y = 0, width = 0 } = viewBox as CartesianViewBox;
          const polygons = [];

          if (!hideMarkerEnds) {
            const triangleSize = 10;
            const halfTriangleSize = triangleSize / 2;
            const fill = color || colors?.[id] || theme.colors.neutral50;

            const triangleOffset = 2;
            const xPosLeft = x + triangleOffset;
            const xPosRight = x + width - triangleOffset;

            polygons.push(
              <polygon
                fill={fill}
                key={0}
                points={`${xPosRight - halfTriangleSize},${y} ${xPosRight + halfTriangleSize},${y - halfTriangleSize} ${
                  xPosRight + halfTriangleSize
                },${y + halfTriangleSize}`}
              />,
              <polygon
                fill={fill}
                key={1}
                points={`${xPosLeft + halfTriangleSize},${y} ${xPosLeft - halfTriangleSize},${y - halfTriangleSize} ${
                  xPosLeft - halfTriangleSize
                },${y + halfTriangleSize}`}
              />
            );
          }

          return (
            <g>
              {polygons}
              {label && (
                <text dy={-8} fontSize={14} x={x} y={y} textAnchor='middle'>
                  <tspan fill={theme.colors.neutral50}>{label}</tspan>{' '}
                  <tspan fontWeight='bold'>{formatter?.(value) ?? value}</tspan>
                </text>
              )}
            </g>
          );
        },
      }}
      stroke={color || colors?.[id]}
      strokeDasharray={dottedLine ? '10 3' : undefined}
      strokeWidth={size}
      y={value}
    />
  ));
};
